import React from "react";
import Chart from "react-apexcharts";
import PropTypes from "prop-types";
import ShimmerLoader from "common/src/components/widget/ShimmerLoader";
import Fragment from "common/src/components/widget/Fragment";
import { useTranslation } from "react-i18next";
import {
  ChartColors
} from "../constants/chartColors";
import {formatSLONumber} from "../utils/FormatNumbers";

const PieChartWidget = ({ id, size = "65%", title, labels, values, colors,
  isLoading = false, useDonut = true, optionOverrides = {} }) => {
  const { t } = useTranslation();

  const options = {
    chart: { id: `pie-chart-widget-${id}` },

    labels: labels.map(t), // localized labels
    legend: {
      position: "bottom",
      onItemClick: {
        toggleDataSeries: false // ensure clicking hides/shows slice
      },
      onItemHover: {
        highlightDataSeries: true
      }
    },
    tooltip: {
      theme: "dark", // or "light"
      fillSeriesColor: false,
      y: {
        formatter: (val) => formatSLONumber(val, 0)
      },
    },
    title: {
      text: t(title),
      align: "center"
    },
    colors,
    states: {
      hover: {
        filter: {
          type: 'darken',
        }
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'darken',
        }
      },
    },
    ...(useDonut && {
      plotOptions: {
        pie: {
          donut: {
            size: size,
            dataLabels: {
              style: {
                fontSize: "16px",
                fontWeight: 500,
              },
              dropShadow: false,
              color: ChartColors.DARK_GRAY
           },
            // pieOptions,
            labels: {
              show: true,
              name: { show: true, fontSize: "16px", offsetY: -10 },
              value: {
                show: true,
                fontSize: "14px",
                fontWeight: 500,
                color: ChartColors.DARK_GRAY,
                offsetY: 10
              },
              total: {
                show: true,
                showAlways: true,
                label: t("Total"),
                fontSize: "14px",
                fontWeight: 500,

                formatter: (w) =>
                    formatSLONumber(
                        w.globals.seriesTotals.reduce((a, b) => a + b, 0),
                        0
                    )
              },

            }
          }
        }
      },
      dataLabels: {
        formatter: (val) => formatSLONumber(val) + "%"
      },
      ...optionOverrides
    })
  };
  return (
      <>
        <Fragment rendered={!isLoading}>
          <Fragment rendered={values?.length > 0}>
            <Chart options={options} series={values} type={useDonut ? "donut" : "pie"}
                   height={400} />
          </Fragment>
          <Fragment rendered={values?.length === 0}>
            <div className="chart-empty-container has-margin-20 has-min-height-300 is-flex flex-vertical flex-justify-center flex-align-items-center">
              <p><i className="fz fz-empty-set extra-large has-text-grey-lighter" /></p>
              <p>{t("No data!")}</p>
            </div>
          </Fragment>
        </Fragment>
        <Fragment rendered={!!isLoading}>
          <div className="chart-loader-container has-margin-20">
            <div className="columns has-margin-top-20">
              <div className="column"><ShimmerLoader /></div>
              <div className="column" />
            </div>
          </div>
        </Fragment>
      </>
  );
};

PieChartWidget.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  title: PropTypes.string.isRequired,
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  values: PropTypes.arrayOf(PropTypes.number).isRequired,
  colors: PropTypes.arrayOf(PropTypes.string).isRequired,
  isLoading: PropTypes.bool,
  useDonut: PropTypes.bool,
  optionOverrides: PropTypes.object
};

export default PieChartWidget;
